<template>
    <div class="home">
        <div class="banner">
        </div>
        <div class="container">
            <div class="item">
                <div class="title">公司简介</div>
                <span class="animated bounceInRight"
                    style="animation-duration: 1s;-webkit-animation-delay: 0.5s;animation-delay: 0.5s; line-height: 30px;font-size: 18px;font-family: 'Signika Negative', sans-serif;">
                    &nbsp;&nbsp;&nbsp;&nbsp;深圳市智汇数能科技有限公司是一家以数据为驱动，算法为赋能的科技公司，致力于通过数据挖掘、文本分析、自然语言处理、机器学习、深度学习等人工智能技术为企业赋能。自主研发打造基于人工智能驱动的智能化产品，
主要产品有：智能水产品批发市场交易系统、智慧餐厅智能化用餐管理系统；
                </span>
                <div style="clear: both;"></div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'home',
    components: {},
    data() {
        return {
            imgs: [],
            homeImgs: [],
            projectList: [],
            projectTypeList: [],
            teamList: [],
            company: {
                configContent: ''
            },
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>
<style lang="less">
.home {
    .banner {
        height: 100%;
        padding: 200px 240px;
        text-align: center;
        font-size: 50px;
        font-weight: bold;
        background: url(../assets/homeBg.jpg) no-repeat 0 0;
        background-size: 100% 100%;
    }

    .container {
        display: flex;
        flex-direction: column;
        min-height: 450px;
        max-width: 80%;
        margin: 0 auto;

        .title {
            text-align: center;
            font-size: 36px;
            color: #00a3e4;
            padding: 10px;
            text-shadow: 2px 2px 4px #e8e8e8;
        }

        .item {
            background-color: #fff;
            width: 100%;
            height: 100%;
            flex-grow: 1;
            padding-top: 1px;

            .en-content {
                display: inline-block;
                border: 1px solid #eee;
                cursor: pointer;
                margin-bottom: 20px;

                .en-img {
                    width: 240px;
                    height: 275px;
                    /*background: url(../assets/info.jpg) no-repeat center center;*/
                    background-size: 100% 100%;
                    transition: all 0.3s;

                    img {
                        width: 240px;
                        height: 275px;
                    }
                }

                .en-text {
                    width: 240px;
                    padding: 5px 10px;
                    box-sizing: border-box;

                    .en-text-title {
                        color: #5a5a5a;
                        padding-bottom: 10px;
                    }

                    .en-text-content {
                        color: #a1a1a1;
                        width: 220px;
                        border-bottom: 1px solid #eee;
                        padding-bottom: 10px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    .en-text-more {
                        color: #888;
                        padding: 5px 0;
                    }
                }
            }

            .en-content:hover {
                .en-img {
                    background-size: 150% 150%;
                }

                .en-text {
                    background-color: #00a3e4;
                }

                .en-text-title,
                .en-text-more,
                .en-text-content {
                    color: #fff;
                }
            }

            .imgC {
                position: relative;
                top: 0;
                float: left;
                width: 50%;
                height: 50%;
                margin-right: 30px;
                margin-right: 12px;
                box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
            }

            .lineText {
                line-height: 40px;
                font-size: 20px;
            }

            .lineText:hover span {
                border-left: 5px solid #e70012;
                padding-left: 12px;
            }

            .el-carousel__item:nth-child(2n) {
                background-color: #99a9bf;
            }

            .el-carousel__item:nth-child(2n+1) {
                background-color: #d3dce6;
            }

        }
    }

}
</style>